import { IconProps } from './types';

export const OverviewIcon = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 21.517 21.517'>
    <g transform='translate(-2 -2)'>
      <path
        d='M22.517,12.759A9.759,9.759,0,1,1,12.759,3,9.759,9.759,0,0,1,22.517,12.759Z'
        fill='none'
        stroke='#fff'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        {...props}
      />
      <path
        d='M18,21.9V18'
        transform='translate(-5.241 -5.241)'
        fill='none'
        stroke='#fff'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        {...props}
      />
      <path
        d='M18,12h0'
        transform='translate(-5.241 -3.145)'
        fill='none'
        stroke='#fff'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        {...props}
      />
    </g>
  </svg>
);
